import React, { useEffect, useState } from "react";
import { GetOutComingNotificationsData } from "../../../lib/data";
import Pagination from "../../../ui/paginations/Paginations";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";

export const OutComingNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const { i18n } = useTranslation();
  const t = i18n.t.bind(i18n); 

  useEffect(() => {
    handleApi(1); // Fetch page 1 on initial load
  }, []);

  // 1. Accept the target page as an argument to avoid using stale state
  const handleApi = async (pageToFetch) => {
    setIsLoading(true);
    const data = await GetOutComingNotificationsData(pageToFetch);

    setNotifications(data.data || []);
    setCurrentPage(data.pagination?.current_page ?? pageToFetch);
    setLastPage(data.pagination?.last_page ?? 1);

    setIsLoading(false);
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > lastPage) return;
    // 2. Pass the new page directly to the API function
    handleApi(page);
  };

  if (isLoading) {
    return (
        <div className="flex justify-center items-center h-[25rem]">
            <ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" />
        </div>
    );
  }

  const renderEmpty = () => (
    <div className="text-center p-8 text-sm text-gray-500">
      No notifications found.
      {/* 3. Pass currentPage when retrying */}
      <button className="ml-2 text-indigo-600 hover:underline" onClick={() => handleApi(currentPage)}>
          {t("notifications.retry")}
      </button>
    </div>
  );

  return (
    <div className="sm:px-8 px-4 py-5">
        <section className="p-6 bg-thirdly rounded-lg shadow">
        <header className="flex items-center justify-between mb-4">
            <h2 className="text-[22px] font-semibold text-white">{t("notifications.outgoing_notifications")}</h2>
            <div className="flex items-center gap-2">
            {/* 3. Pass currentPage when manually refreshing */}
            <button className="text-sm text-gray-400 hover:text-secondary" onClick={() => handleApi(currentPage)} aria-label="Refresh notifications">
                {t("notifications.refresh")}
            </button>
            </div>
        </header>

        {notifications.length === 0 ? (
        renderEmpty()
        ) : (
        <ul
            role="list"
            aria-label="Notifications list"
            className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-4"
        >
            {notifications.map((n, key) => (
            <li
                key={n.id}
                className="sm:p-4 p-3 gap-3 bg-furthly rounded shadow"
            >
                <div className="flex-1 min-w-0">
                <div className="flex items-center justify-end">
                    <span className="font-semibold sm:text-[18px] text-[17px] text-white truncate">
                        {`  ${n.title}`}  
                    </span>
                    <span className="font-semibold sm:text-[16px] text-[15px] text-white truncate mr-1">
                        -{key}
                    </span>
                </div>
                <p className="sm:text-[14px] text-end text-[12px] text-gray-300 mt-1 line-clamp-2">
                    {n.description}
                </p>
                </div>
                <div className="flex justify-between items-center mt-1">
                    <span className="text-xs text-left text-gray-500 ml-2">
                        {formatDate(n.created_at)}
                    </span>
                </div>
            </li>
            ))}
        </ul>
        )}

        {/* Pagination */}
        <div className="flex justify-center items-center mt-4">
<Pagination 
  currentPage={currentPage} 
  totalPages={lastPage} 
  handleChangePage={handlePageChange} 
/>        </div>
        </section>
    </div>
  );
};

// Helper: format relative time (simple example)
function formatDate(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  const diff = Date.now() - d.getTime();
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
}